import React from 'react';
import { cautionIcon, newCheckmark } from '../../../images/btnIcons';
import './ActionSheetModal.css';
import { alertIcon } from '../../../images/images';
import { Button } from 'unified-ui-components-library'

const ActionSheetModal = ({buttons=null, modalType, heading, description, additionalDescription=null}) => {
    return <div className="actionsheet-ovrlay" >
        <div className="actionsheet-cntnr" >
            <div className="actionsheet-texts" >
                <p className="alrt-icn"><img src={modalType === "success" ? newCheckmark : modalType === "BI_Failed" ? alertIcon :(cautionIcon)} alt="alrt-icn" /></p>
                <p className={modalType === "success" ? "actionsheet-incorrect-ans-msg actionsheet-success-msg":"actionsheet-incorrect-ans-msg"}>{heading}</p>
                <p className="actionsheet-review-ans-msg">{description}</p>
                {additionalDescription && <p className="actionsheet-review-ans-msg">{additionalDescription}</p>}
            </div>
            {buttons && <div className={`actionsheet-btns ${buttons.length === 1 ? 'flex-center-btn' : ''}`} >  
                {
                    buttons.map((btn, index)=>(
                        <Button 
                        key={index} 
                        className={btn.cancel ? 'cust_fab_submit_all submit_all_btn exit-btn': 'cust_fab_submit_all submit_all_btn'}
                        onClick={btn.action}
                        >
                            {btn.text}
                        </Button>
                    ))
                }
            </div>}
        </div>
    </div>
}

export default ActionSheetModal